import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgSmartContracts = function SvgSmartContracts(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_66_24770",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_66_24770)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_66_24770)",
        fillOpacity: 0.16,
        d: "M17.995 71.217Q19.777 73 22.334 73h41.333q2.556 0 4.339-1.783 1.782-1.783 1.783-4.339V16.471q0-.856-.795-1.144-.795-.289-1.398.378l-2.038 2.038-3.521-3.393q-.315-.337-.842-.337-.525 0-.839.328l-3.516 3.402-3.521-3.393q-.315-.337-.842-.337-.525 0-.839.328l-3.516 3.402-3.521-3.393q-.315-.337-.841-.337-.527 0-.84.328l-3.516 3.402-3.495-3.393q-.321-.337-.848-.337t-.84.328l-3.516 3.402-2.038-2.038q-.603-.603-1.398-.378t-.794 1.121v43.603h-7.956q-.98 0-1.644.664-.663.663-.663 1.644v4.52q0 2.555 1.782 4.338"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_66_24770)",
        d: "M18.334 69q-2.556 0-4.34-1.783-1.782-1.783-1.782-4.339v-4.52q0-.98.663-1.643.663-.664 1.644-.664h7.955V12.45q0-.899.795-1.122.795-.225 1.398.378l2.038 2.038 3.517-3.402q.312-.328.839-.328t.848.337l3.495 3.393 3.516-3.402q.313-.328.84-.328t.84.337l3.522 3.393 3.516-3.402q.313-.328.84-.328t.84.337l3.522 3.393 3.516-3.402q.312-.328.84-.328.526 0 .84.337l3.522 3.393 2.038-2.038q.603-.666 1.398-.378t.795 1.144v50.407q0 2.556-1.783 4.339T59.666 69zm41.365-2.564q1.506 0 2.516-1.01t1.01-2.548v-47.98H25.039V56.05h28.827q.98 0 1.644.664.663.663.663 1.644v4.524q0 1.533 1.01 2.543t2.516 1.01M31.359 26.46q-.487 0-.843-.367t-.356-.927.369-.914.913-.356H46.7q.545 0 .913.374.369.374.369.926 0 .553-.369.909-.368.355-.913.355zm0 10.59q-.487 0-.843-.4a1.35 1.35 0 0 1-.356-.927q0-.525.369-.881t.913-.356H46.7q.545 0 .913.374.369.374.369.926 0 .553-.369.908-.368.356-.913.356zm24.308-9.692q-.872 0-1.526-.654t-.654-1.526.654-1.525T55.667 23t1.526.654q.653.654.653 1.525 0 .872-.653 1.526-.654.654-1.526.654m0 10.365q-.872 0-1.526-.654-.654-.653-.654-1.525t.654-1.526q.654-.654 1.526-.654t1.526.654q.653.654.653 1.526 0 .871-.653 1.525-.654.654-1.526.654M18.268 66.436H53.61v-7.82H14.776v4.262q0 1.539 1.022 2.548t2.47 1.01"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_66_24770",
        x1: 16.771,
        x2: 69.043,
        y1: 43.506,
        y2: 43.506,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_66_24770",
        x1: 12.771,
        x2: 65.043,
        y1: 39.506,
        y2: 39.506,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgSmartContracts as ReactComponent };
//# sourceMappingURL=SmartContracts.svg.es.js.map
